export default "__VITE_ASSET__D_hyX97O__"